import React from 'react';

import Tippy from '@tippyjs/react';

import { cn } from 'lib/helpers/utility';

import Icon from '../Icon/Icon';

const Hint = ({
  hint,
  icon = 'info-filled',
  iconSize = 16,
  tooltip,
  disabled,
  error,
  className,
  tooltipClassName,
  iconShade = 500
}) => {
  if (!hint) return null;

  return (
    <Tippy content={tooltip} disabled={!tooltip} className={cn('tippy-dark', tooltipClassName)}>
      <div className={cn('flex items-center gap-x-1 pt-2', className)}>
        {icon && (
          <Icon
            icon={icon}
            color={error ? 'danger' : 'neutral'}
            size={iconSize}
            shade={disabled ? 400 : iconShade}
          />
        )}
        <p
          className={cn(
            'text-sm',
            disabled ? 'text-neutral-400' : error ? 'text-danger-500' : 'text-neutral-700'
          )}>
          {hint}
        </p>
      </div>
    </Tippy>
  );
};

export default Hint;
